<span class="icon">
    <span class="icon__line"></span> <span class="icon__line"></span> <span class="icon__line"></span>
    <span class="icon__line"></span> <span class="icon__line"></span>
</span>
